import { helper } from '@ember/component/helper';
import DOCS from 'nightwatch-web/constants/docs';

export const docsUrl = ([key]) => DOCS[key] || 'https://docs.nightwatch.io';

export default helper(docsUrl);
